function roundToTwo(num: number) {
  if (num && typeof num === "number") {
    return (num * 100) / 100;
  } else {
    return 0;
  }
}

export const estimateValidateForm = (
  estimateForm: any,
  isCostSection: boolean,
  screenType: any,
) => {
  let isError = false;
  const localError: any = {};

  // =========================
  // SERVICES VALIDATION
  // =========================
  estimateForm?.services?.forEach((service: any, index: number) => {
    // protect against invalid entries (arrays of true/false etc) which
    // occasionally slip in when users rapidly toggle fields; if a primitive
    // is found we simply ignore it rather than crashing.
    if (typeof service !== "object" || service === null) {
      return;
    }
    const normalizedTypeName = String(
      service?.typeName || service?.type_name || service?.service_name || "",
    )
      .toLowerCase()
      .trim();

    const isRemoval =
      normalizedTypeName === "removal" ||
      normalizedTypeName === "removal, door to door" ||
      normalizedTypeName === "removal door to door";

    const numericPrice = Number(service?.price);
    const priceValid =
      service?.price !== null &&
      service?.price !== undefined &&
      service?.price !== "" &&
      Number.isFinite(numericPrice) &&
      numericPrice >= 0;

    // Only Removal service price is required.
    if (isRemoval) {
      // make sure we always store an object for this row so later spreads
      // don't try to merge into a boolean.  existing callers were doing
      // `localError.services = { ...localError.services, [index]: true }`
      // which sets a primitive and then the vehicles logic blows up when it
      // attempts to spread it.  normalize it here up front.
      const existingRowError =
        typeof localError.services?.[index] === "object" &&
        localError.services[index] !== null
          ? localError.services[index]
          : {};

      if (!priceValid) {
        isError = true;
        localError.services = {
          ...localError.services,
          [index]: {
            ...existingRowError,
            // we don't need a specific flag for the basic check; the
            // presence of an object is enough for the UI in most cases,
            // but we copy through existingRowError in case previous steps
            // added other flags (e.g. vehicles).
          },
        };
      }

    }
  });

  return { isError, localError };
};

// calculated profit (totalQuote - totalCost/ totalQuote * 100)
export const calculateProfit = (totalQuote: number, totalCost: number) => {

  if (totalQuote <= 0) return 0;

  const profit = ((totalQuote - totalCost) / totalCost) * 100;

  // force 2 decimal places
  return Number(profit.toFixed(2));
};

export const getTotal = (column: any, formData: any) => {
  const formRef = formData;
  let total: number = 0;
  switch (column) {
    case "total":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.total || 0));
      });
      break;
    case "volume":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.volume || 0));
      });
      break;
    case "cost":
      formRef?.materials?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.cost || 0));
      });
      break;
    case "ancillaries":
      formRef?.ancillaries?.map((cost: any) => {
        // Only add charge if isChargeable is true
          total = roundToTwo(total + Number(cost?.charge || 0));
      });
      break;
    case "wages":
      formRef?.services?.map((cost: any) => {
        total = roundToTwo(total + Number(cost?.wageCharge || 0));
      });
      break;
    case "costsCost":
      formRef?.services?.forEach((service: any) => {
        if (Array.isArray(service.vehicles)) {
          service.vehicles.forEach((vehicle: any) => {
            total = roundToTwo(total + Number(vehicle?.fuelCharge || 0));
          });
        }
      });
      break;
    case "serivesCost":
      formRef?.services?.map((service: any) => {
        total = roundToTwo(total + Number(service?.price || 0));
      });
      break;
    case "subcontractorCharges":
      formRef?.subcontractorCharges?.map((charge: any) => {
        total = roundToTwo(total + Number(charge?.chargeAmount || 0));
      });
      break;
    default:
      total = 0;
  }
  return total;
};

export const estimateChangeAction = (
  event: any,
  section: any,
  index: any,
  valueFormat: any,
  estimateForm: any,
  vehicles: any,
  subContractors: any,
) => {
  const { id, value } = event.target;
  
  let formClone: any = {};
  // Handle generalInfo updates properly
  if (id === "materialPriceChargeable" || id === "vatIncluded") {
    formClone = {
      ...estimateForm,
      [id]: event?.target?.checked,
    };
  } else if (
    id === "quoteExpiresOn" ||
    id === "notes" ||
    id === "quotenote" ||
    id === "transportnote" ||
    id === "paymentMethod" ||
    id === "insurancePercentage" ||
    id === "insuranceAmount" ||
    id === "insuranceType" ||
    id === "contentValue"
  ) {
    formClone = {
      ...estimateForm,
      [id]: valueFormat === "number" ? (value ? Number(value) : value) : value,
    };
  } else if (section === "generalInfo") {
    // Map index to specific generalInfo keys if index is provided
    let key = id;
    if (typeof index === "number") {
      if (index === 0) key = "driverWage";
      else if (index === 1) key = "porterWage";
      else if (index === 2) key = "packerWage";
    }
    formClone = {
      ...estimateForm,
      generalInfo: {
        ...estimateForm.generalInfo,
        [key]:
          valueFormat === "number" ? (value ? Number(value) : value) : value,
      },
    };
  } else if (
    typeof section === "string" &&
    section.startsWith("services[") &&
    section.endsWith("].vehicles")
  ) {
    // Parse service index from section string
    const serviceMatch = section.match(/services\[(\d+)\]\.vehicles/);
    const serviceIdx = serviceMatch ? parseInt(serviceMatch[1], 10) : null;
    if (serviceIdx !== null && Array.isArray(estimateForm.services)) {
      formClone = {
        ...estimateForm,
        services: estimateForm.services.map((service: any, sIdx: number) => {
          if (sIdx !== serviceIdx) return service;
          return {
            ...service,
            vehicles: service.vehicles.map((veh: any, vIdx: number) => {
              if (vIdx !== index) return veh;
              if (id === "vehicleTypeId") {
                return {
                  ...veh,
                  vehicleTypeId: value,
                  vehicleQty: 1,
                  orderIndex: vIdx,
                  isFuelChargeManual: false,
                };
              }
              if (id === "fuelCharge") {
                return {
                  ...veh,
                  fuelCharge:
                    valueFormat === "number" && value !== ""
                      ? Number(value)
                      : value,
                  isFuelChargeManual: true,
                };
              }
              if (id === "vehicleQty") {
                return {
                  ...veh,
                  vehicleQty:
                    valueFormat === "number" && value !== ""
                      ? Number(value)
                      : value,
                  isFuelChargeManual: false,
                };
              }
              return {
                ...veh,
                [id]:
                  valueFormat === "number" && value !== ""
                    ? Number(value)
                    : value,
              };
            }),
          };
        }),
      };
    } else {
      formClone = { ...estimateForm };
    }
  } else {
    formClone = {
      ...estimateForm,
      [section]: [
        ...(Array.isArray(estimateForm[section])
          ? estimateForm[section]
          : []
        )?.map((ele: any, i: any) => {
          let extraFields: any = {};
          if (i === index) {
            switch (section) {
              case "materials":
                const chargeQty = id === "chargeQty" ? value : ele?.chargeQty;
                const price = id === "price" ? value : ele?.price;
                const surveyedQty =
                  id === "surveyedQty" ? value : ele?.surveyedQty;
                if (chargeQty && price) {
                  extraFields.total = roundToTwo(
                    Number(chargeQty) * Number(price),
                  );
                } else {
                  extraFields.total = chargeQty === 0 || price === 0 ? 0 : "";
                }
                if (surveyedQty && price) {
                  extraFields.cost = roundToTwo(
                    Number(surveyedQty) * Number(price),
                  );
                } else {
                  extraFields.cost = surveyedQty === 0 || price === 0 ? 0 : "";
                }
                break;
              case "services":
                if (
                  id === "vehicleTypeId" ||
                  id === "fuelCharge" ||
                  id === "vehicleQty"
                ) {
                  // If vehicles array is null/undefined, create it with a default entry
                  const currentVehicles = Array.isArray(ele.vehicles)
                    ? ele.vehicles
                    : [
                        {
                          orderIndex: 0,
                          vehicleQty: null,
                          vehicleTypeId: "",
                          fuelCharge: null,
                        },
                      ];

                  return {
                    ...ele,
                    vehicles: currentVehicles.map((veh: any, vIndex: number) => {
                      if (vIndex === 0) {
                        // or use vehicleIndex
                        let updatedVehicle = { ...veh };

                        if (id === "vehicleTypeId") {
                          const findVehicle = vehicles.find(
                            (v: any) => v?.type_id === value,
                          );

                          updatedVehicle.vehicleTypeId = value;
                          updatedVehicle.vehicleQty =
                            findVehicle && findVehicle?.count
                              ? findVehicle.count
                              : 1;
                          updatedVehicle.isFuelChargeManual = false;
                        }

                        if (id === "fuelCharge") {
                          updatedVehicle.fuelCharge =
                            valueFormat === "number" && value !== ""
                              ? Number(value)
                              : value;
                          updatedVehicle.isFuelChargeManual = true;
                        }

                        if (id === "vehicleQty") {
                          updatedVehicle.vehicleQty =
                            valueFormat === "number" && value !== ""
                              ? Number(value)
                              : value;
                          updatedVehicle.isFuelChargeManual = false;
                        }

                        return updatedVehicle;
                      }
                      return veh;
                    }),
                  };
                }
                break;
              case `services[${index}].vehicles`:
                if (
                  id === "vehicleTypeId" ||
                  id === "fuelCharge" ||
                  id === "vehicleQty"
                ) {
                  return {
                    ...ele,
                    vehicles: ele.vehicles?.map((veh: any, vIndex: number) => {
                      if (vIndex === index) {
                        // or use vehicleIndex
                        let updatedVehicle = { ...veh };

                        if (id === "vehicleTypeId") {
                          const findVehicle = vehicles.find(
                            (v: any) => v?.type_id === value,
                          );

                          updatedVehicle.vehicleTypeId = value;
                          updatedVehicle.vehicleQty =
                            findVehicle && findVehicle?.count
                              ? findVehicle.count
                              : 1;
                          updatedVehicle.isFuelChargeManual = false;
                        }

                        if (id === "fuelCharge") {
                          updatedVehicle.fuelCharge =
                            valueFormat === "number" && value !== ""
                              ? Number(value)
                              : value;
                          updatedVehicle.isFuelChargeManual = true;
                        }

                        if (id === "vehicleQty") {
                          updatedVehicle.vehicleQty =
                            valueFormat === "number" && value !== ""
                              ? Number(value)
                              : value;
                          updatedVehicle.isFuelChargeManual = false;
                        }

                        return updatedVehicle;
                      }
                      return veh;
                    }),
                  };
                }
                break;
              case "subcontractorCharges":
                if (id === "subContractorId") {
                  const findSubContractor = subContractors.find(
                    (ele: any) => ele?.id === value,
                  );
                  if (findSubContractor && findSubContractor?.name) {
                    extraFields.name = findSubContractor?.name;
                  } else {
                    extraFields.name = "";
                  }
                }
                break;
              default:
                extraFields = {};
            }
          }
          return i !== index
            ? ele
            : {
                ...ele,
                [id]:
                  id === "day" && value === ""
                    ? null
                    : valueFormat === "number" && value
                    ? Number(value)
                    : valueFormat === "price"
                      ? value
                      : id === "isChargeable"
                        ? event?.target?.checked
                        : value,
                ...extraFields,
              };
        }),
      ],
    };
  }
  formClone.services = formClone?.services?.map((ele: any, idx: any) => {
    return {
      ...ele,
      wageCharge: roundToTwo(
        Number(ele?.driverQty) * Number(formClone?.generalInfo?.driverWage) +
          Number(ele?.porterQty) * Number(formClone?.generalInfo?.porterWage) +
          Number(ele?.packerQty) * Number(formClone?.generalInfo?.packerWage),
      ),
    };
  });

  if (id === "insurancePercentage" && formClone?.services?.[0]?.price) {
    if (formClone?.insurancePercentage > 0) {
      formClone = {
        ...formClone,
        insuranceAmount: roundToTwo(
          (parseFloat(formClone?.insurancePercentage) / 100) *
            parseFloat(formClone?.services?.[0]?.price),
        ),
      };
    } else {
      formClone = {
        ...formClone,
        insuranceAmount: 0,
      };
    }
  } else if (id === "insuranceAmount" && formClone?.services?.[0]?.price) {
    if (formClone?.insuranceAmount > 0) {
      formClone = {
        ...formClone,
        insurancePercentage: roundToTwo(
          (parseFloat(formClone?.insuranceAmount) /
            parseFloat(formClone?.services?.[0]?.price)) *
            100,
        ),
      };
    } else {
      formClone = {
        ...formClone,
        insurancePercentage: 0,
      };
    }
  } else if ( id==="price" && section === "services" &&
    formClone?.services?.[0]?.typeName === "Removal" &&
    formClone?.services?.[0]?.price &&
    formClone?.insurancePercentage &&
    formClone?.insurancePercentage > 0
  ) {
    const insuranceAmount = roundToTwo(
      (parseFloat(formClone.insurancePercentage) / 100) *
        parseFloat(formClone.services[0].price),
    );

    const insurancePercentage = roundToTwo(
      (insuranceAmount / parseFloat(formClone.services[0].price)) * 100,
    );

    formClone = {
      ...formClone,
      insuranceAmount,
      insurancePercentage,
    };
  } 
  else {
    if (formClone) {
      formClone = {
        ...formClone,
        // insurancePercentage: 0,
        // insuranceAmount: 0,
      };
    }
  }

  const chargeableAncillariesTotal = (formClone?.ancillaries || [])
    .filter((a: any) => a?.isChargeable)
    .reduce((sum: number, a: any) => roundToTwo(sum + Number(a?.charge || 0)), 0);

  if (formClone?.materialPriceChargeable) {
    formClone.quoteTotal = roundToTwo(
      getTotal("total", formClone) +
        getTotal("serivesCost", formClone) +
        parseFloat(formClone?.insuranceAmount || 0) +
        chargeableAncillariesTotal,
    );
  } else {
    formClone.quoteTotal = roundToTwo(
      getTotal("serivesCost", formClone) +
        parseFloat(formClone?.insuranceAmount || 0) +
        chargeableAncillariesTotal,
    );
  }
  formClone.costTotal = roundToTwo(
    getTotal("costsCost", formClone) +
      getTotal("wages", formClone) +
      getTotal("cost", formClone) +
      getTotal("ancillaries", formClone) +
      getTotal("subcontractorCharges", formClone),
  );

  return { estimateData: formClone };
};
